import { type Page } from '#shared/api/schema';
import { CONSTRUCTOR_RENAME_PAGES } from '../constants';

export const canConstructorPageRename = (page: Page) =>
    // Созданные пользователем + некоторые с алиасом + шаблоны, созданные пользователем
    !page.alias || CONSTRUCTOR_RENAME_PAGES.includes(page.alias) || page.variant_type === 'alternative';
